exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".parsed-number-popover-table tr{min-width:120px;display:flex;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/code/UI/Math/DisplayNumber.scss
// module id = 50
// module chunks = 0